import { Loader } from 'components/Loader/Loader';
import { signIn } from 'lib/AuthClient/SignInAuth';
import React, { ChangeEvent, FC, KeyboardEvent, useState } from 'react';
import { ForgotPasswordBox } from './ForgotPasswordBox';
import { InteractiveBackground } from './InteractiveBackground';
import porterbuddyLogo from './porterbuddy.svg';
import './SignIn.scss';

const SignInBox: FC<{ changeState: () => void }> = ({ changeState }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showWarning, setShowWarning] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [signInMessage, setSignInMessage] = useState<string>('');

  const isCourierSubdomain = window.location.host.includes('courier');

  const signInMethod = async event => {
    event.preventDefault();

    setShowLoading(true);
    try {
      const [success, authMessage] = await signIn(email, password);
      setSignInMessage(authMessage);
      if (success) {
        setShowLoading(false);
      } else {
        setShowLoading(false);
        setShowWarning(!authMessage);
      }
    } catch (error) {
      setShowLoading(false);
      setShowWarning(false);
    }
  };

  const handleKeyPress = async (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      await signInMethod(event);
    }
  };

  return (
    <form className="container">
      {isCourierSubdomain ? (
        <h2>Please use courier app to log in</h2>
      ) : (
        <>
          <h2>Sign in – Dispatch</h2>
          <input
            type="text"
            className="form-email"
            placeholder="Email"
            autoComplete="email"
            autoCapitalize="none"
            autoCorrect="off"
            value={email}
            minLength={2}
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              setEmail(event.target.value)
            }
            onKeyPress={(event: KeyboardEvent) => handleKeyPress(event)}
          />

          <input
            type="password"
            className="form-password"
            placeholder="Password"
            autoComplete="current-password"
            value={password}
            minLength={6}
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              setPassword(event.target.value)
            }
            onKeyPress={(value: KeyboardEvent) => handleKeyPress(value)}
          />
          {showLoading && (
            <div style={{ textAlign: 'center' }}>
              <Loader type="bounce" size="large" />
            </div>
          )}
          {signInMessage.length > 0 && (
            <div className="singInMessage"> {signInMessage}</div>
          )}
          {showWarning && (
            <div className="errorLogin">The email or password is incorrect</div>
          )}
          <button
            className="signin"
            onClick={async event => await signInMethod(event)}
          >
            Sign In
          </button>
          <button className="naked-button" onClick={changeState}>
            Forgot Password?
          </button>
        </>
      )}
    </form>
  );
};

type SignInProps = {
  showSignInBox: boolean;
};

const SignIn: FC<SignInProps> = (props: SignInProps) => {
  const [showSignInBox, setShowSignInBox] = useState(props.showSignInBox);

  const changeState = () => {
    setShowSignInBox(!showSignInBox);
  };

  return (
    <InteractiveBackground className="sign-in">
      <img
        className="porterbuddy-logo"
        alt="Porterbuddy"
        src={porterbuddyLogo}
      />
      {showSignInBox ? (
        <SignInBox changeState={changeState} />
      ) : (
        <ForgotPasswordBox changeState={changeState} />
      )}
    </InteractiveBackground>
  );
};

export default SignIn;
